import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@shiftfinancial/design-system';
import Grid from '@material-ui/core/Grid';

import StepContainer from '../steps/StepContainer';
import FormItem from '../../core/FormItem';
import PhoneNumberInput from '../../core/PhoneNumberInput';
import CompositeAlert from '../../core/CompositeAlert';
import phoneNumberUtils from '../../../utils/phoneNumberUtils';

class Banklink extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSendSmsForBankConnection = this.handleSendSmsForBankConnection.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.clearTimer();
  }

  handleSendSmsForBankConnection() {
    this.props.sendBanklinkSms();
  }

  handleSubmit() {
    this.props.restart();
  }

  render() {
    const {
      mobileNumber,
      canResendSmsForBankConfirmation,
      sendSmsForBankConfirmation,
      registrationStatus,
    } = this.props;
    const formattedMobileNumber = phoneNumberUtils.replaceLocalCode(mobileNumber);

    const sendButtonLabel = canResendSmsForBankConfirmation
      ? 'Send SMS for bank connection'
      : 'Resend available in 1 minute...';
    const sendButtonDisabled =
      !canResendSmsForBankConfirmation || sendSmsForBankConfirmation.isRequesting;
    let alert;
    switch (registrationStatus) {
      case 'Pending':
        alert = (
          <CompositeAlert
            variant="warning"
            message="Thank You for entering the details. The contact status is pending and requires further action"
          />
        );
        break;
      case 'Completed':
      default:
        alert = (
          <CompositeAlert
            variant="success"
            message="Registration has been successfully completed and the contact is now created"
          />
        );
    }

    return (
      <StepContainer
        isSubmitVisible
        isSubmitDisabled={false}
        onSubmit={this.handleSubmit}
        submitButtonAppearance="secondary"
        submitLabel="Finish"
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {alert}
          </Grid>
          <FormItem label="Mobile number">
            <Grid item container spacing={3} alignItems="center">
              <Grid item xs={12} sm={6}>
                <PhoneNumberInput
                  name="mobileNumber"
                  pattern="^4[0-9]{2} [0-9]{3} [0-9]{3}|^04[0-9]{2} [0-9]{3} [0-9]{3}"
                  format="### ### ###"
                  readOnly
                  value={formattedMobileNumber}
                  data-testid="mobileNumber"
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <Button
                  appearance="primary"
                  disabled={sendButtonDisabled}
                  pending={sendSmsForBankConfirmation.isRequesting}
                  data-testid="sendSmsButton"
                  onClick={this.handleSendSmsForBankConnection}
                >
                  {sendButtonLabel}
                </Button>
              </Grid>
            </Grid>
          </FormItem>
          <Grid item xs={12}>
            {sendSmsForBankConfirmation.isError && (
              <CompositeAlert variant="error" message={sendSmsForBankConfirmation.message} />
            )}
            {!sendSmsForBankConfirmation.isError && sendSmsForBankConfirmation.isSubmitted && (
              <CompositeAlert variant="success" message={sendSmsForBankConfirmation.message} />
            )}
          </Grid>
        </Grid>
      </StepContainer>
    );
  }
}

Banklink.propTypes = {
  mobileNumber: PropTypes.string.isRequired,
  clearTimer: PropTypes.func.isRequired,
  sendBanklinkSms: PropTypes.func.isRequired,
  canResendSmsForBankConfirmation: PropTypes.bool,
  sendSmsForBankConfirmation: PropTypes.shape({
    isSubmitted: PropTypes.bool,
    isError: PropTypes.bool,
    message: PropTypes.string,
    isRequesting: PropTypes.bool,
  }),
  restart: PropTypes.func.isRequired,
  registrationStatus: PropTypes.oneOf(['Pending', 'Completed']),
};

Banklink.defaultProps = {
  canResendSmsForBankConfirmation: true,
  sendSmsForBankConfirmation: {},
  registrationStatus: 'Completed',
};

export default Banklink;
